<p class="paragraph-15" *ngIf="!linkSent">{{'resetPassword.description' | translate}}</p>
<p class="paragraph-15" *ngIf="linkSent">
    {{'resetPassword.linkSent' | translate:{email: resetForm.value.email} }}
</p>

<form [formGroup]="resetForm" (ngSubmit)="sendLink()" *ngIf="!linkSent">
    <ion-input type="email" formControlName="email"
               minlength="5"
               maxlength="50"
               [email]="true"
               [placeholder]="'features-auth.email' | translate"></ion-input>
    <div *ngIf="resetForm.controls.email.errors && resetForm.controls.email.errors.api"
         class="error paragraph-15">
        {{resetForm.controls.email.errors.api}}
    </div>

    <ion-button class="ion-margin-top" type="submit" expand="block" [disabled]="resetForm.invalid">
        {{'resetPassword.send' | translate}}
    </ion-button>
</form>
